import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-integration',
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './integration.component.html',
    styleUrl: './integration.component.css'
})
export class IntegrationComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  @Input() isLoading: boolean = false;
  constructor() {}
  navigateToJiraOAuth() {
    let authToken = localStorage.getItem('accessToken');
    let endpoint = environment.api_endpoint;
    this.isLoading = true;
    const authUrl = `${endpoint}/jira/oauth/start?fl=userOauthFlow&at=${authToken}`;
    window.open(authUrl, '_blank');
  }
}
